// src/components/ProfileUpdatePage/ProfileUpdatePage.jsx
import React, { useState, useEffect, useCallback } from 'react';
// import './ProfileUpdatePage.css'; // We'll create this CSS file
import AboutLabTab from '../layouts/AboutLabTab';
import ContactPersonTab from '../layouts/ContactPersonTab';
import OrgDetailsTab from '../layouts/OrgDetailsTab';
import * as api from "../layouts/DummyApi"
import { get, put } from "../../utility/fetch"

const ProfileUpdatePage = () => {
    const [activeTab, setActiveTab] = useState('orgDetails');
    const [orgDetails, setOrgDetails] = useState(null);
    const [contactPerson, setContactPerson] = useState(null);
    const [aboutLab, setAboutLab] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isUpdating, setIsUpdating] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    // Fetch all initial data
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            setError('');
            try {
                const [orgRes, contactRes, aboutRes] = await Promise.all([
                    fetchOrgDetails(),
                      fetchContactPerson(),
                    //   fetchAboutLab(),
                    
                ]);
                // setOrgDetails(orgRes.data);
                // setContactPerson(contactRes.data);
                // setAboutLab(aboutRes.data);
            } catch (err) {
                console.error("Failed to fetch profile data:", err);
                setError("Failed to load profile data. Please try again.");
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleSave = useCallback(async (dataToSave, updateFunction, setDataFunction) => {
        setIsUpdating(true);
        setError('');
        setSuccessMessage('');
        try {
            const response = await updateFunction(dataToSave);
            if (response.success) {
                setDataFunction(response.data); // Update state with confirmed data from API
                setSuccessMessage("Profile updated successfully!");
            } else {
                throw new Error(response.message || "Failed to update profile.");
            }
        } catch (err) {
            console.error("Update error:", err);
            setError(err.message || "An error occurred during update.");
        } finally {
            setIsUpdating(false);
            setTimeout(() => setSuccessMessage(''), 3000); // Clear success message
            setTimeout(() => setError(''), 5000); // Clear error message
        }
    }, []);


    const fetchOrgDetails = async () => {
        try {
            let res = await get(`/healthCareProvider/healthCareProvider/id/${sessionStorage.getItem("healthCareProviderId")}`)
            console.log(res)
            setOrgDetails(res)
        } catch (error) {
            console.log(error)
        }

    }

    const fetchContactPerson = async () => {
        try {
            let res = await get(`/healthCareProvider/healthCareProvidercontactPersonbyproviderid?id=${sessionStorage.getItem("healthCareProviderId")}`)
            console.log(res)
            setContactPerson((res?.length < 1 || !res) ? {} : res)
        } catch (error) {
            console.log(error)
        }
    }

    const handleSaveOrg = async (data) =>{
console.log(data)
        let res = await put(`/healthcareprovider/${sessionStorage.getItem("healthCareProviderId")}`, data)
    }

    const handleSaveContact = async (data) =>{
        console.log(data)
        let res = await put(`/healthcareprovider/healthCareprovidercontactperson/${sessionStorage.getItem("healthCareProviderId")}`, data)
        
    }
//    const fetchAboutLab = async () => {
//         try {
//             let res = await get(`/aboutLab/healthCareProvider/id/${sessionStorage.getItem("healthCareProviderId")}`)
//             console.log(res)
//             setAboutLab(res)
//         } catch (error) {
//             console.log(error)
//         }
//    }

    const renderTabContent = () => {
        if (isLoading) {
            return <div className="loading-state">Loading profile data...</div>;
        }
        if (error && !isUpdating) { // Show initial fetch error, not temporary update errors
            return <div className="error-state">{error}</div>;
        }

        switch (activeTab) {
            case 'orgDetails':
                return (
                    <OrgDetailsTab
                        orgDetails={orgDetails}
                        setOrgDetails={setOrgDetails}
                        onSave={(data) => handleSaveOrg(data)}
                    />
                );
            case 'contactPerson':
                return (
                    <ContactPersonTab
                        contactPerson={contactPerson}
                        setContactPerson={setContactPerson}
                        onSave={(data) => handleSaveContact(data)}
                    />
                );
            case 'aboutLab':
                return (
                    <AboutLabTab
                        aboutLab={aboutLab}
                        setAboutLab={setAboutLab}
                        // onSave={(data) => handleSave(data, updateAboutLab, setAboutLab)}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <div className="w-100 profile-update-page">
            <h1>Update Profile</h1>
            <div className="tab-navigation">
                <button
                    className={activeTab === 'orgDetails' ? 'active' : ''}
                    onClick={() => setActiveTab('orgDetails')}
                >
                    Org Details
                </button>
                <button
                    className={activeTab === 'contactPerson' ? 'active' : ''}
                    onClick={() => setActiveTab('contactPerson')}
                >
                    Contact Person
                </button>
                {/* <button
                    className={activeTab === 'aboutLab' ? 'active' : ''}
                    onClick={() => setActiveTab('aboutLab')}
                >
                    About Lab
                </button> */}
            </div>

            {isUpdating && <div className="loading-indicator">Saving...</div>}
            {successMessage && <div className="success-message">{successMessage}</div>}
            {error && isUpdating && <div className="error-message">{error}</div>} {/* Show update-specific errors */}

            <div className="tab-content">
                {renderTabContent()}
            </div>
        </div>
    );
};

export default ProfileUpdatePage;